import { Textarea } from '@jisr-hr/ds-beta'
import i18n from 'translations/i18n'

type TextBasedAnswersProps = {
  value: string | undefined
  handleChange: (text: string) => void
}

export function TextBasedAnswers({ value, handleChange }: TextBasedAnswersProps) {
  return (
    <div className="w-[50vw] mx-auto mobile:w-[90vw]">
      <Textarea
        value={value}
        height={150}
        placeholder={i18n.t('placeholder.survey_type_your_answer_here')}
        onChange={(e) => handleChange(e)}
      />
    </div>
  )
}
